import React, { useState } from 'react'
import {
  Button,
  TextField,
  Heading,
  Typography,
  Frame,
} from 'components'
import { updateUser, useContent } from 'utils'
import { Box } from '@material-ui/core'
import { ProgressBarFooter } from './FreelancerProgressBarFooter'
import { VALID_URI_REGEX } from '../FreelancerProfile/FreelancerEditProfile'

const FreelancerLinksForm = ({ 
  onboarding, 
  user, 
  onNext, 
  stepIndex, 
  totalSteps 
}) => {
  const { landing } = useContent() || {}
  const buttonColor = landing?.['onboarding-button-color'] || 'primary'
  const buttonSecondaryColor = landing?.['onboarding-button-secondary'] || '#6c757d'
  // Initialize state for all the different links
  const [portfolioUrl, setPortfolioUrl] = useState(user?.portfolioUrl || '')
  const [portfolioPassword, setPortfolioPassword] = useState(user?.portfolioPassword || '')
  const [demoReelLink, setDemoReelLink] = useState(user?.demoReelLink || '')
  const [imdbLink, setImdbLink] = useState(user?.imdbLink || '')
  const [linkedInLink, setLinkedInLink] = useState(user?.linkedInLink || '')
  const [instagramLink, setInstagramLink] = useState(user?.instagramLink || '')

  const isValidLink = (link) => {
    return !link || VALID_URI_REGEX.test(link)
  }

  const allLinksValid = () => {
    return (
      isValidLink(portfolioUrl) &&
      isValidLink(demoReelLink) &&
      isValidLink(imdbLink) &&
      isValidLink(linkedInLink) &&
      isValidLink(instagramLink)
    )
  }

  const handleSubmit = () => {
    // Only update valid links
    const updates = {
      portfolioUrl: isValidLink(portfolioUrl) ? portfolioUrl : '',
      portfolioPassword,
      demoReelLink: isValidLink(demoReelLink) ? demoReelLink : '',
      imdbLink: isValidLink(imdbLink) ? imdbLink : '',
      linkedInLink: isValidLink(linkedInLink) ? linkedInLink : '',
      instagramLink: isValidLink(instagramLink) ? instagramLink : ''
    }

    updateUser(user, updates).then(() => {
      if (onNext) {
        onNext()
      }
    })
  }

  return (
    <Frame maxWidth="xs">
      <Box mx="auto" maxWidth={430}>
        <Heading>
          You can showcase your work. Please list any relevant websites.
        </Heading>

        <Box mb={4}>
          <Box display="flex" flexDirection="column" style={{ gap: 1 }}>
            {/* Portfolio URL and password */}
            <Box>
              <Box display="flex" style={{ gap: 64 }}>
                <TextField 
                  fullWidth
                  value={portfolioUrl} 
                  onChange={(e) => setPortfolioUrl(e.target.value)} 
                  name="portfolioUrl" 
                  label="Portfolio Site URL" 
                />
                <TextField 
                  fullWidth
                  value={portfolioPassword} 
                  onChange={(e) => setPortfolioPassword(e.target.value)} 
                  name="portfolioPassword" 
                  label="Portfolio Site Password" 
                  placeholder="If required"
                />
              </Box>
            </Box>

            {/* Demo Reel Link */}
            <Box>
              <TextField 
                fullWidth
                value={demoReelLink} 
                onChange={(e) => setDemoReelLink(e.target.value)} 
                name="demoReelLink" 
                label="Demo Reel Link" 
              />
            </Box>

            {/* IMDB Link */}
            <Box>
              <TextField 
                fullWidth
                value={imdbLink} 
                onChange={(e) => setImdbLink(e.target.value)} 
                name="imdbLink" 
                label="IMDB Link" 
              />
            </Box>

            {/* LinkedIn Link */}
            <Box>
              <TextField 
                fullWidth
                value={linkedInLink} 
                onChange={(e) => setLinkedInLink(e.target.value)} 
                name="linkedInLink" 
                label="LinkedIn Link" 
              />
            </Box>

            {/* Instagram Link */}
            <Box>
              <TextField 
                fullWidth
                value={instagramLink} 
                onChange={(e) => setInstagramLink(e.target.value)} 
                name="instagramLink" 
                label="Instagram Link" 
              />
            </Box>
          </Box>

          {/* Add Another Link button */}
          <Box mt={4}>
            <Button
              variant="contained"
              style={{ 'background-color': buttonSecondaryColor, color: 'white' }}
              fullWidth
            >
              Add Another Link
            </Button>
          </Box>
        </Box>
      </Box>

      {onboarding && (
        <ProgressBarFooter
          valid={allLinksValid()}
          stepIndex={stepIndex}
          firstStep={stepIndex}
          numSteps={totalSteps}
          onNext={handleSubmit}
          onPrev={() => {}}
        />
      )}
    </Frame>
  )
}

export default FreelancerLinksForm
